import { decimalToNumber } from '../../utils/grpcUtil';
var mapper = {
  fromDto: function fromDto(dto) {
    return {
      id: dto.id,
      amountDueNow: maybeDecimalToNumber(dto.amountDueNow),
      coupon: dto.coupon ? mapCoupon(dto.coupon) : null,
      jobScopeItemNames: dto.jobScopeItemNamesList,
      primaryAmount: maybeDecimalToNumber(dto.primaryAmount),
      total: maybeDecimalToNumber(dto.total)
    };
  }
};
function maybeDecimalToNumber(value) {
  return value ? decimalToNumber(value) : 0;
}
function mapCoupon(coupon) {
  return {
    id: coupon.id,
    code: coupon.code,
    amount: maybeDecimalToNumber(coupon.amount)
  };
}
export default mapper;
//# sourceMappingURL=QuoteMapper.js.map
